import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

/**
 * A warm phone shell for mobile session replays and live previews. Mobile
 * replays come through as wireframes (PostHog mobile→rrweb), so this frames
 * that content the way it would appear on device.
 */
export function DeviceFrame({
  children,
  className,
  notch = true,
}: {
  children: ReactNode;
  className?: string;
  notch?: boolean;
}) {
  return (
    <div
      className={cn(
        "relative mx-auto w-full max-w-[260px] rounded-[34px] border-[6px] border-ink-strong/90 bg-ink-strong p-1 shadow-md",
        className,
      )}
    >
      {notch && (
        <div className="absolute left-1/2 top-1.5 z-10 h-4 w-20 -translate-x-1/2 rounded-full bg-ink-strong" />
      )}
      <div className="relative aspect-[9/19] w-full overflow-hidden rounded-[28px] bg-canvas">
        {children}
      </div>
    </div>
  );
}
